import { useState } from 'react'
import {
  Avatar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'

import { ProductViewsDashboardModal } from '../product-views-dashboard'
import { ETranslationNs, IAccountProductViews } from 'src/types'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProductsViewsTableProps {
  rows: IAccountProductViews[]
}

const ProductsViewsTable = ({ rows }: IProductsViewsTableProps) => {
  const [viewsProduct, setViewsProduct] = useState<{ id: string; name: string } | null>(null)
  const classes = useStyles()

  const handleOpenModal = (productId: string, productName: string) => () => {
    setViewsProduct({ id: productId, name: productName })
  }

  const handleCloseModal = () => {
    setViewsProduct(null)
  }

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" />
              <TableCell>
                <HelperWrapper t="products-views-product-column" ns={ETranslationNs.Common} />
              </TableCell>
              <TableCell align="center">
                <HelperWrapper t="products-views-views-column" ns={ETranslationNs.Common} />
              </TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>
                  <Avatar
                    sx={{ margin: '0 auto' }}
                    alt={row.name}
                    src={row.image_small || row.image}
                  />
                </TableCell>
                <TableCell component="th" scope="row">
                  <p className={classes.productTitle}>
                    {<strong>{row.name}</strong>}
                    {'\n'}#{row.code}
                  </p>
                </TableCell>
                <TableCell align="center">{row.views}</TableCell>
                <TableCell align="center">
                  <Button onClick={handleOpenModal(row.id, row.name)}>
                    <HelperWrapper t="view-stats-button-text" ns={ETranslationNs.Common} />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ProductViewsDashboardModal
        productId={viewsProduct?.id!}
        productName={viewsProduct?.name!}
        open={!!viewsProduct}
        handleClose={handleCloseModal}
      />
    </>
  )
}

export { ProductsViewsTable }
